// extracted by mini-css-extract-plugin
export var dropdownButton = "_u-0";
export var fullWidthDropdownButton = "_u-1";
export var icon = "_u-3";
export var iconPlaceholder = "_u-2";
export var menuItemRow = "_u-9";
export var separator = "_u-e";
export var shortcutContainer = "_u-7";
export var shortcutContainerFilled = "_u-8";
export var shortcutIconLg = "_u-6";
export var shortcutIconMd = "_u-5";
export var shortcutIconSm = "_u-4";
export var submenuChevron = "_u-d";
export var submenuDropdown = "_u-a";
export var submenuTriggerRow = "_u-b";
export var submenuTriggerRowOpen = "_u-c";